import { render, staticRenderFns } from "./SpeedingHeatMap.vue?vue&type=template&id=20f525fa&scoped=true"
import script from "./SpeedingHeatMap.vue?vue&type=script&lang=js"
export * from "./SpeedingHeatMap.vue?vue&type=script&lang=js"
import style0 from "./SpeedingHeatMap.vue?vue&type=style&index=0&id=20f525fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f525fa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SpeedingWarningList: require('/home/vsts/work/1/s/components/SpeedingWarningList.vue').default,GlobalWarningComboBox: require('/home/vsts/work/1/s/components/global/WarningComboBox.vue').default,GlobalDateRange: require('/home/vsts/work/1/s/components/global/DateRange.vue').default,TDRoutesOnMap: require('/home/vsts/work/1/s/components/TDRoutesOnMap.vue').default,GlobalDrawerList: require('/home/vsts/work/1/s/components/global/DrawerList.vue').default})
